import { render, staticRenderFns } from "./QuerySummary.vue?vue&type=template&id=56f8cd3a"
import script from "./QuerySummary.vue?vue&type=script&lang=ts"
export * from "./QuerySummary.vue?vue&type=script&lang=ts"
import style0 from "./QuerySummary.vue?vue&type=style&index=0&id=56f8cd3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports